/**
 * Depracated - redirect them to our web site
 */
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-demo',
  templateUrl: './demo.component.html'
})
export class DemoComponent implements OnInit {

  constructor() {}

  ngOnInit() {
    window.location.href = `https://siftrock.com`;
  }
}




// WEBPACK FOOTER //
// ./client/app/demo/demo.component.ts